module.exports = __webpack_public_path__ + "static/media/ic-DPA.7371136b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-DPA.svg
// module id = 1291
// module chunks = 17